import { render, staticRenderFns } from "./Changepassword.vue?vue&type=template&id=682ac758&scoped=true&"
import script from "./Changepassword.vue?vue&type=script&lang=js&"
export * from "./Changepassword.vue?vue&type=script&lang=js&"
import style0 from "./Changepassword.vue?vue&type=style&index=0&id=682ac758&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682ac758",
  null
  
)

export default component.exports